import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';

const PaymentDialog = ({
  paymentDialog, setPaymentDialog,
  paymentDate, setPaymentDate,
  paymentNotes, setPaymentNotes,
  savePayment, isAdmin,
}) => {
  return (
    <Dialog open={!!paymentDialog} onOpenChange={v => { if (!v) setPaymentDialog(null); }}>
      <DialogContent className="max-w-sm z-50">
        <DialogHeader><DialogTitle>Update Payment Status</DialogTitle><DialogDescription>Set payment details for this bill</DialogDescription></DialogHeader>
        <div className="space-y-4 pt-2">
          <div><Label>Payment Date</Label><Input type="date" value={paymentDate} onChange={e => setPaymentDate(e.target.value)} data-testid="payment-date-input" /></div>
          <div><Label>Notes (optional)</Label><Input value={paymentNotes} onChange={e => setPaymentNotes(e.target.value)} placeholder="e.g. Cheque #12345" data-testid="payment-notes-input" /></div>
          <div className="flex gap-2 justify-end">
            <Button variant="outline" onClick={() => setPaymentDialog(null)}>Cancel</Button>
            {paymentDialog?.currentStatus === 'paid'
              ? isAdmin && <Button className="bg-orange-600 hover:bg-orange-700" onClick={() => savePayment('unpaid')} data-testid="mark-unpaid-btn">Mark Unpaid</Button>
              : <Button className="bg-green-600 hover:bg-green-700" onClick={() => savePayment('paid')} data-testid="mark-paid-btn">Mark Paid</Button>}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentDialog;
